export enum ContentType {
  image,
  pdf
}
